"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveEndpoint = exports.getEndpoint = exports.getEndpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _constants = require("./constants");

var getEndpoints = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, forms, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch("http://localhost:".concat(_constants.PORT, "/endpoints"));

          case 3:
            response = _context.sent;

            if (!(response.status === 200)) {
              _context.next = 11;
              break;
            }

            forms = [];
            _context.next = 8;
            return response.json();

          case 8:
            data = _context.sent;
            data.forEach(function (api, index) {
              var obj = {
                formId: index,
                endpoint: api.endpoint,
                method: api.method,
                responseBody: JSON.stringify(api.responseBody, null, 2),
                responseCode: api.responseCode,
                delay: api.delay,
                dataAmount: api.dataAmount || '1',
                isActive: Boolean(api.isActive)
              };
              forms.push(obj);
            });
            return _context.abrupt("return", forms);

          case 11:
            return _context.abrupt("return", null);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", null);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function getEndpoints() {
    return _ref.apply(this, arguments);
  };
}();

exports.getEndpoints = getEndpoints;

var getEndpoint = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(type) {
    var response, forms, data;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return fetch("http://localhost:".concat(_constants.PORT, "/endpoints/").concat(type));

          case 3:
            response = _context2.sent;

            if (!(response.status === 200)) {
              _context2.next = 11;
              break;
            }

            forms = [];
            _context2.next = 8;
            return response.json();

          case 8:
            data = _context2.sent;
            data.forEach(function (api, index) {
              var obj = {
                formId: index,
                endpoint: api.endpoint,
                method: api.method,
                responseBody: JSON.stringify(api.responseBody, null, 2),
                responseCode: api.responseCode,
                delay: api.delay,
                dataAmount: api.dataAmount || '1',
                isActive: Boolean(api.isActive)
              };
              forms.push(obj);
            });
            return _context2.abrupt("return", forms);

          case 11:
            return _context2.abrupt("return", null);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", null);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 14]]);
  }));

  return function getEndpoint(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getEndpoint = getEndpoint;

var saveEndpoint = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(type, form) {
    var myHeaders, requestOptions, result;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: JSON.stringify(form)
            };
            _context3.next = 6;
            return fetch("http://localhost:".concat(_constants.PORT, "/endpoints/").concat(type), requestOptions);

          case 6:
            result = _context3.sent;

            if (!(result.status === 200)) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return", true);

          case 9:
            return _context3.abrupt("return", false);

          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", false);

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 12]]);
  }));

  return function saveEndpoint(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.saveEndpoint = saveEndpoint;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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